import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home.tsx";
import EO from "./pages/EO.tsx";
import Widget from "./pages/Widget.tsx";
import Home2 from "./pages/Home2.tsx";
import Gracehill from "./pages/Gracehill.tsx";
import Thumbtack from "./pages/Thumbtack.tsx";
import ClassWallet from "./pages/ClassWallet.tsx";
import RiseWellTherapy from "./pages/RiseWellTherapy.tsx";
import RiseWellTheRapyv3 from "./pages/RiseWellTheRapyv3.tsx";
import RiseWellTherapyCSR from "./pages/RiseWellTherapyCSR.tsx";
import NurseRateReview from "./pages/NurseRateReview.tsx";
import Vixa from "./pages/Vixa.tsx";
import ElevateLearning from "./pages/ElevateLearning.tsx";
import WavelyAir from "./pages/WavelyAir.tsx";
import FloraGlow from "./pages/FloraGlow.tsx";
import FloraGlowNew from "./pages/FloraGlowNew.tsx";
import Demo1 from "./pages/Demo1.tsx";
import Demo2 from "./pages/Demo2.tsx";
import Demo3 from "./pages/Demo3.tsx";
import Demo4 from "./pages/Demo4.tsx";
import Demo5 from "./pages/Demo5.tsx";
import MissionTelecom from "./pages/MissionTelecom.tsx";
import OneImaging1 from "./pages/OneImaging1.tsx";
import OneImaging2 from "./pages/OneImaging2.tsx";
import TrueAir from "./pages/TrueAir.tsx";
import ClearPath from "./pages/ClearPath.tsx";
import ElevateLearningNew from "./pages/ElevateLearningNew.tsx";
import RiseWellTherapyNew from "./pages/RiseWellTherapyNew.tsx";
import CustomerServiceSkillsTraining from "./pages/CustomerServiceSkillsTraining.tsx";
import JobInterviewReadiness from "./pages/JobInterviewReadiness.tsx";
import RiseWellTheRapySpanish from "./pages/RiseWellTheRapySpanish.tsx";
import EasyPA from "./pages/EasyPA.tsx";
import PrimoBrands from "./pages/PrimoBrands.tsx";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/EO" element={<EO />} />
        <Route path="/Home2" element={<Home2 />} />
        <Route path="/Gracehill" element={<Gracehill />} />
        <Route path="/Thumbtack" element={<Thumbtack />} />
        <Route path="/ClassWallet" element={<ClassWallet />} />
        <Route path="/Widget" element={<Widget />} />
        <Route path="/RiseWellTherapy" element={<RiseWellTherapy />} /> 
        <Route path="/RiseWellTherapyCSR" element={<RiseWellTherapyCSR />} /> 
        <Route path="/RiseWellTheRapyv3" element={<RiseWellTheRapyv3 />} /> 
        <Route path="/NurseRateReview" element={<NurseRateReview />} /> 
        <Route path="/Vixa" element={<Vixa />} /> 
        <Route path="/ElevateLearning" element={<ElevateLearning />} /> 
        <Route path="/WavelyAir" element={<WavelyAir />} /> 
        <Route path="/FloraGlow" element={<FloraGlow />} /> 
        <Route path="/FloraGlowNew" element={<FloraGlowNew />} /> 
        <Route path="/Demo1" element={<Demo1 />} /> 
        <Route path="/Demo2" element={<Demo2 />} /> 
        <Route path="/Demo3" element={<Demo3 />} /> 
        <Route path="/Demo4" element={<Demo4 />} /> 
        <Route path="/Demo5" element={<Demo5 />} /> 
        <Route path="/MissionTelecom" element={<MissionTelecom />} /> 
        <Route path="/OneImaging1" element={<OneImaging1 />} /> 
        <Route path="/OneImaging2" element={<OneImaging2 />} /> 
        <Route path="/TrueAir" element={<TrueAir />} /> 
        <Route path="/ClearPath" element={<ClearPath />} /> 
        <Route path="/ElevateLearningNew" element={<ElevateLearningNew />} /> 
        <Route path="/RiseWellTherapyNew" element={<RiseWellTherapyNew />} /> 
        <Route path="/CustomerServiceSkillsTraining" element={<CustomerServiceSkillsTraining />} /> 
        <Route path="/JobInterviewReadiness" element={<JobInterviewReadiness />} /> 
        <Route path="/RiseWellTheRapySpanish" element={<RiseWellTheRapySpanish />} /> 
        <Route path="/EasyPA" element={<EasyPA />} />
        <Route path="/PrimoBrands" element={<PrimoBrands />} />
      </Routes>
    </Router>
  );
};

export default App;
